import { viewportContext } from '../context/viewportProvider'

import { useContext } from 'react'

export const useViewport = () => {
  const { width, height, screenWidth } = useContext(viewportContext)
  return { width, height, screenWidth }
}
